import { ROLE_PERMISSIONS, type CustomerRole, type PermissionKey } from '@mpange/types';

const ROUTE_PERMISSIONS: Array<{ prefix: string; permission: PermissionKey }> = [
  { prefix: '/dashboard/contacts', permission: 'contacts.read' },
  { prefix: '/dashboard/campaigns', permission: 'campaigns.read' },
  { prefix: '/dashboard/sms/send', permission: 'sms.send' },
  { prefix: '/dashboard/sms', permission: 'sms.read' },
  { prefix: '/dashboard/sender-ids', permission: 'sender_ids.read' },
  { prefix: '/dashboard/channels', permission: 'channels.read' },
  { prefix: '/dashboard/ivr', permission: 'ivr.read' },
  { prefix: '/dashboard/analytics', permission: 'analytics.read' },
  { prefix: '/dashboard/developers', permission: 'developers.read' },
  { prefix: '/dashboard/billing/topup', permission: 'wallet.topup' },
  { prefix: '/dashboard/billing', permission: 'billing.read' },
  { prefix: '/dashboard/team', permission: 'organization.members.read' },
  { prefix: '/dashboard/kyc', permission: 'kyc.read' },
  { prefix: '/dashboard/support', permission: 'support.read' },
  { prefix: '/dashboard/reseller', permission: 'reseller.customers.read' },
  { prefix: '/dashboard/audit', permission: 'organization.read' },
  { prefix: '/dashboard/organization', permission: 'organization.read' },
];

function requiredPermission(path: string): PermissionKey | null {
  if (path === '/dashboard') return null;
  const match = ROUTE_PERMISSIONS.find(
    (route) => path === route.prefix || path.startsWith(`${route.prefix}/`),
  );
  return match?.permission ?? null;
}

export function permissionsForRole(roleKey: string | undefined): PermissionKey[] {
  if (!roleKey) return [];
  return ROLE_PERMISSIONS[roleKey as CustomerRole] ?? [];
}

export function userHasPermission(roleKey: string | undefined, permission: PermissionKey): boolean {
  return permissionsForRole(roleKey).includes(permission);
}

export function canAccessRoute(roleKey: string | undefined, path: string): boolean {
  const permission = requiredPermission(path);
  if (!permission) return true;
  return userHasPermission(roleKey, permission);
}
